export default __webpack_public_path__ + "static/media/editUpdatePen.b9eec431.svg";